module.exports = __webpack_public_path__ + "img/U1F631.15becd44.png";